import React from "react";
import PropTypes from "prop-types";
import { AlertStyle } from "./styles";
import ReactSVG from 'react-svg';
import alertWarning from "~/assets/img/icon/alert-warning.svg";
import alertSuccess from "~/assets/img/icon/alert-success.svg";
import alertError from "~/assets/img/icon/alert-error.svg";

export default function Alert({
  children,
  type,
  size = 'md',
}) {
  return (
    <AlertStyle type={type} size={size}>
      <div className="icon">
        {type === "warning" && <ReactSVG src={alertWarning}/> }
        {type === "success" && <ReactSVG src={alertSuccess}/> }
        {type === "error" && <ReactSVG src={alertError}/> }
      </div>
      {children}
    </AlertStyle>
  );
}

Alert.defaultProps = {
  type: "warning",
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

Alert.propTypes = {
  type: PropTypes.oneOf(["warning", "success", "error"]),
};
